import Decimal from "break_infinity.js";
import React from "react";

export function prettifyNumber(n: number | Decimal) {
  n = new Decimal(n);
  if (n.gte(1e12)) {
    return n.toPrecision(3).toString().replace("+", "");
  }
  if (n.gte(1e9)) {
    const formattedNumber = n
      .div(1e9)
      .toNumber()
      .toLocaleString("en-US", {
        minimumIntegerDigits: 1,
        minimumFractionDigits: n.gte(1e11) ? 0 : n.gte(1e10) ? 1 : 2,
        maximumFractionDigits: n.gte(1e11) ? 0 : n.gte(1e10) ? 1 : 2,
      });
    return formattedNumber + "B";
  } else if (n.gte(1e6)) {
    const formattedNumber = n
      .div(1e6)
      .toNumber()
      .toLocaleString("en-US", {
        minimumIntegerDigits: 1,
        minimumFractionDigits: n.gte(1e8) ? 0 : n.gte(1e7) ? 1 : 2,
        maximumFractionDigits: n.gte(1e8) ? 0 : n.gte(1e7) ? 1 : 2,
      });
    return formattedNumber + "M";
  } else if (n.gte(1e3)) {
    const formattedNumber = n
      .div(1e3)
      .toNumber()
      .toLocaleString("en-US", {
        minimumIntegerDigits: 1,
        minimumFractionDigits: n.gte(1e5) ? 0 : n.gte(1e4) ? 1 : 2,
        maximumFractionDigits: n.gte(1e5) ? 0 : n.gte(1e4) ? 1 : 2,
      });
    return formattedNumber + "K";
  }
  return n.toFixed(0);
}

export function ChemicalFormulaRenderer({ formula }: { formula: string }) {
  const elements: React.ReactElement[] = [];

  for (let i = 0; i < formula.length; i++) {
    const char = formula[i];
    const isNumeric = /\d/.test(char);

    if (isNumeric) {
      // Handle numeric subscript
      const subscript = parseInt(char, 10);
      elements.push(<sub key={i}>{subscript}</sub>);
    } else {
      // Handle element symbol
      elements.push(<span key={i}>{char}</span>);
    }
  }

  return <div>{elements}</div>;
}
